import '@/services/auth'

import { combineReducers } from '@reduxjs/toolkit'
import { useSelector as useReactReduxSelector } from 'react-redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { api } from '@/services/base'

import auth from './slices/authSlice'

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
}

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  auth,
})

export default persistReducer(rootPersistConfig, rootReducer)

export type RootState = ReturnType<typeof rootReducer>
export const useSelector = useReactReduxSelector.withTypes<RootState>()
